import { fetch } from '@/base-http'
import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Obtiene el link de acceso a un recurso del gestor de contenidos
 *
 * @param type
 * @param id
 * @param attributes
 */
export async function getResourceLink (type: string, id: number | string, attributes: KeyValuePair = {}) {
    const data = await fetch('/cms/resource-link', {
        params: { type, id, attributes: JSON.stringify(attributes) },
    })

    return data.link as string
}
